import { IconFn, IconSvg } from "../createIcon";

export const CommunicationsIcon: IconFn = ({ color = "white", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 22, height: 22 }} stroke={color} {...props}>
    <path stroke="none" d="M0 0h24v24H0z"></path>
    <path d="M4 21V8a3 3 0 013-3h10a3 3 0 013 3v6a3 3 0 01-3 3H8l-4 4"></path>
    <path d="M8 9L16 9"></path>
    <path d="M8 13L14 13"></path>
  </IconSvg>
);
